<div class="app-container">


    <app-update-alert></app-update-alert>

    <router-outlet></router-outlet>

    <app-cookies></app-cookies>

</div>